import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div(
  props => `
  height: ${props.height ? props.height : '520px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media ${device.mobileS} {
    ${p =>
      p.panVerified &&
      `
            height: 100%;
            align-items: unset;
            justify-content: unset;
            text-align: left;
        `}
  }
`,
);

export const Heading = styled.h3`
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  font-size: 24px;
  line-height: 40px;
  color: #2f281e;
  margin-bottom: 8px;
  @media ${device.mobileS} {
    font-size: 26px;
    line-height: 32px;
    text-align: left;
  }
`;
export const Icon = styled.span`
  width: 28px;
  flex-shrink: 0;
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  img {
    width: 28px;
  }
  @media ${device.mobileS} {
    width: 20px;
    margin-right: 8px;
  }
`;
export const SubHeading = styled.p`
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  margin-bottom: 58px;
  @media ${device.mobileS} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const LinkButton = styled.button`
  background: none !important;
  margin-top: 40px;
`;

export const ClauseText = styled.p`
  font-size: 12px;
  line-height: 24px;
  color: #000000;
  margin-top: 38px;
  @media ${device.mobileS} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Info = styled.div(
  props => `
  margin-top: ${!props?.subHeading ? '40px' : ''};
  margin-top: ${props?.marginTop ? props.marginTop : ''};
  background: #ffffff;
  border: 1px solid #008cff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px 25px;
  cursor: pointer;
  @media ${device.mobileS} {
    margin-top: auto;
    margin-bottom: 30px;
  }
`,
);
export const InfoText = styled.p`
  font-size: 16px;
  color: #333333;
  font-weight: 700;
  display: flex;
  align-items: center;
  span {
    font-size: 12px;
    color: #999999;
    margin-left: 5px;
    font-weight: 400;
  }
  @media ${device.mobileS} {
    font-size: 12px;
  }
`;
export const ImpInfo = styled.div`
  background-color: #ffedd1;
  border-radius: 4px;
  padding: 10px;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 20px;
  p {
    font-size: 14px;
    line-height: 20px;
    color: #000;
  }
  @media ${device.mobileS} {
    font-size: 12px;
  }
`;

export const PopHeaderWrap = styled.div(
  props => `
        display: flex;
        width:100%;
        align-items: center;
        justify-content: ${props.alignRight ? 'space-between' : 'flex-end'};
        @media only screen and (max-width:768px){
            margin-top:2rem;
        }
    `,
);

export const PopHeaderBackWrap = styled.div(
  props => `
        display: flex;
        align-items: center;
        width:20%;
        opacity: ${props.disabled ? '0.5' : '1'};
        pointer-events: ${props.disabled ? 'none' : ''};
        justify-content: ${props.alignRight ? 'flex-start' : 'flex-end'};
    `,
);

export const PopHeaderMainWrap = styled.div(
  props => `
        display: flex;
        width:100%;
        justify-content: end;
    `,
);

export const PopHeaderBackText = styled.a(
  props => `
        color: #000;
        font-size: 1.2rem;
        font-weight: bold;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
    `,
);
